module.exports = __webpack_public_path__ + "img/txt_info3.64593747.png";